import {ReactNode, useCallback, useMemo} from 'react'
import {IAbnormalMark, IAmountDiffer, IUnknownTransfer, postAbnormal} from '../../../apis/abnormal/abnormal'
import ContainerLayout from '../../../components/layout/ContainerLayout'
import WizTable from '../../../components/table/TableFactory'
import Text from '../../../components/text/Text'
import {ComponentItem, CreateComponent} from '../../../components/useComponent'
import {useDisplayNumber} from '../../../utils/number'
import WizButton from '../../../components/button/WizButton'
import {useTime} from '../../../utils/time'

interface IProps {
    className?: string
    data: IUnknownTransfer
    yesterdayTotal: number
    todayTotal: number
}

const AbnormalInfoContainer: React.FC<IProps> = ({className, data, yesterdayTotal, todayTotal}) => {
    const {toFixedNumber} = useDisplayNumber()
    const {convertUtc0ToUtc9} = useTime()
    const headerTitles: string[] = ['Amount', 'Symbol', 'Added At', 'Action']
    const headers: ComponentItem[] = headerTitles.map<ComponentItem>(el => ({
        component: Text,
        props: {
            children: el,
        },
    }))

    const els = useMemo(() => {
        if (data?.amounts === undefined) {
            return []
        }
        return data?.amounts?.map<ReactNode[]>(el => {
            console.log(el.added_at)
            return [
                <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                    {CreateComponent(Text, {children: el.amount})}
                </div>,
                <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                    {CreateComponent(Text, {children: el.symbol})}
                </div>,
                <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                    {CreateComponent(Text, {children: el.added_at})}
                </div>,
                <WizButton text={'Mark Balance'} size="medium" type={'red'} onClick={() => markToOrder(el)} />,
            ]
        })
    }, [data])

    const markToOrder = useCallback(async (ud: IAmountDiffer) => {
        const body: IAbnormalMark = {
            key_id: data.key_id,
            symbol: ud.symbol,
            amount: ud.amount,
            added_at: ud.added_at,
        }
        try {
            await postAbnormal(body)
        } catch (err) {
            console.log(err)
        }
    }, [])
    return (
        <ContainerLayout title={'Abnormal Info'} className={`${className}`}>
            <ContainerLayout className={'text-center'} containerClassName="grid grid-cols-3">
                <Text className={'text-ti2 text-font03'}>Today Total</Text>
                <Text className={'text-ti2 text-font03'}>Yesterday Total</Text>
                <Text className={'text-ti2 text-font03'}>Diff Day</Text>

                <Text className={'text-ti2'}>{toFixedNumber(todayTotal ? todayTotal : 0)} USD</Text>
                <Text className={'text-ti2'}>{toFixedNumber(yesterdayTotal ? yesterdayTotal : 0)} USD</Text>
                <Text className={'text-ti2'}>
                    {todayTotal && yesterdayTotal && toFixedNumber(todayTotal - yesterdayTotal)} USD
                </Text>
            </ContainerLayout>
            <WizTable gridCols={'4'} headers={headers} items={els}></WizTable>
        </ContainerLayout>
    )
}

export default AbnormalInfoContainer
